import {Observable, Scheduler, Subscriber} from "rxjs";
import {BrowserTheme} from "./BrowserTheme";

export class BrowserThemeStore {

    public static id = "browserThemeStore";

    private readonly currentTheme$: Observable<BrowserTheme>;

    public constructor() {
        this.currentTheme$ = this.initMatcher().shareReplay(1);
    }

    private initMatcher(): Observable<BrowserTheme> {
        return Observable.create((subscriber: Subscriber<BrowserTheme>) => {
            const match = window.matchMedia("(prefers-color-scheme: dark)");
            if (match.matches) {
                subscriber.next(BrowserTheme.DARK);
            } else {
                subscriber.next(BrowserTheme.LIGHT);
            }
            match.addListener((change) => {
                if (change.matches) {
                    subscriber.next(BrowserTheme.DARK);
                } else {
                    subscriber.next(BrowserTheme.LIGHT);
                }
            });
        });
    }

    public get current(): Observable<BrowserTheme> {
        return this.currentTheme$.observeOn(Scheduler.async);
    }
}
